import type { ReactNode, SelectHTMLAttributes } from "react";
import { injectCss } from "../core/injectCss";

const CSS = `
.js-select-wrap{position:relative;display:flex;flex-direction:column;gap:6px;font-family:var(--font-sans)}
.js-select-wrap__label{font-size:var(--text-sm);font-weight:var(--weight-semibold);color:var(--text-body)}
.js-select-inner{position:relative;display:flex;align-items:center}
.js-select{
  width:100%;height:var(--control-md);box-sizing:border-box;appearance:none;
  font-family:var(--font-sans);font-size:var(--text-body);color:var(--text-strong);
  background:var(--surface-card);border:1.5px solid var(--border-default);
  border-radius:var(--radius-md);padding:0 38px 0 14px;cursor:pointer;
  transition:border-color var(--dur-fast),box-shadow var(--dur-fast);
}
.js-select:hover{border-color:var(--border-strong)}
.js-select:focus{outline:none;border-color:var(--brand);box-shadow:var(--ring-brand)}
.js-select[disabled]{background:var(--neutral-100);color:var(--text-subtle);cursor:not-allowed}
.js-select-caret{position:absolute;right:13px;pointer-events:none;color:var(--text-muted);font-size:11px}
`;

export interface SelectOption {
  value: string;
  label: ReactNode;
}

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: ReactNode;
  options?: SelectOption[];
  placeholder?: string;
}

export function Select({ label, id, className = "", children, options, placeholder, ...rest }: SelectProps) {
  injectCss("js-select-css", CSS);
  return (
    <div className="js-select-wrap">
      {label && (
        <label className="js-select-wrap__label" htmlFor={id}>
          {label}
        </label>
      )}
      <span className="js-select-inner">
        <select id={id} className={["js-select", className].filter(Boolean).join(" ")} {...rest}>
          {placeholder && <option value="">{placeholder}</option>}
          {options
            ? options.map((o) => (
                <option key={o.value} value={o.value}>
                  {o.label}
                </option>
              ))
            : children}
        </select>
        <span className="js-select-caret">▼</span>
      </span>
    </div>
  );
}
